import { RadioGroup } from "@portal/BaseComponents/Radio/AntRadio";
import { GenericRadioChangeEvent } from "@portal/BaseComponents/Radio/types";
import { documentFiltersAtom } from "@portal/store/Filters/documents/document-filter";
import { documentViewOptions } from "@portal/store/Filters/documents/predicate";
import { DocumentViews } from "@portal/store/Filters/documents/type";
import { resetPage, tableAtom } from "@portal/store/table/table";
import produce from "immer";
import { useAtom, useSetAtom } from "jotai";

function DocumentView() {
  const [, setDocumentFilters] = useAtom(documentFiltersAtom);
  const setTable = useSetAtom(tableAtom);
  function onChange(event: GenericRadioChangeEvent<DocumentViews>) {
    setDocumentFilters((filter) => {
      return produce(filter, (draft) => {
        draft.filterValues.entity_types =
          event.target.value === "ALL"
            ? ["CUSTOMER", "INVOICE"]
            : ([event.target.value] as DocumentViews[]);
      });
    });
    setTable(resetPage);
  }
  return (
    <RadioGroup
      optionType="button"
      options={documentViewOptions}
      buttonStyle="solid"
      defaultValue={"ALL"}
      onChange={onChange}
    />
  );
}

export { DocumentView };
